module.exports = __webpack_public_path__ + "img/deimos.ea7fc160.png";